var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49998 1.83366C4.74059 1.83366 4.12498 2.44927 4.12498 3.20866C4.12498 3.96805 4.74059 4.58366 5.49998 4.58366C6.25937 4.58366 6.87498 3.96805 6.87498 3.20866C6.87498 2.44927 6.25937 1.83366 5.49998 1.83366ZM3.20831 3.20866C3.20831 1.94301 4.23433 0.916992 5.49998 0.916992C6.76563 0.916992 7.79165 1.94301 7.79165 3.20866C7.79165 4.47431 6.76563 5.50033 5.49998 5.50033C4.23433 5.50033 3.20831 4.47431 3.20831 3.20866Z",
    fill: "#161B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12498 7.33366C3.36559 7.33366 2.74998 7.94927 2.74998 8.70866V9.62533C2.74998 9.87846 2.54478 10.0837 2.29165 10.0837C2.03852 10.0837 1.83331 9.87846 1.83331 9.62533V8.70866C1.83331 7.44301 2.85933 6.41699 4.12498 6.41699H6.87498C8.14063 6.41699 9.16665 7.44301 9.16665 8.70866V9.62533C9.16665 9.87846 8.96144 10.0837 8.70831 10.0837C8.45518 10.0837 8.24998 9.87846 8.24998 9.62533V8.70866C8.24998 7.94927 7.63437 7.33366 6.87498 7.33366H4.12498Z",
    fill: "#161B2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.6c6756e4be37b4eaee1874f6df64802a.svg";
export { ForwardRef as ReactComponent };